export const merchants = {
  makemytrip: {
    logo: 'https://staging-app.zestmoney.in/staging-merchants-assets/logo-icons/mmt holiday-logo-icon.png',
    logoTarget: 'https://www.makemytrip.com/promos/nce-zestmoney-24062019.html',
    logoEvent: 'CL_approved_page_MMT_logo_click',
    description: 'Head over to MakeMyTrip, select ZestMoney EMI as your payment option, and enjoy the easy EMI for any bookings',
    ctaText: 'GO TO MAKEMYTRIP',
    ctaTarget: 'https://www.makemytrip.com/promos/nce-zestmoney-24062019.html',
    ctaEvent: 'CL_approved_page_MMT_CTA_click',
    steps: [
      {
        step: 1,
        image: '/assets/images/offlineGC/makemytrip/1.png',
        text: 'Head to MMT, select your flight or package & click book'
      },
      {
        step: 2,
        image: '/assets/images/offlineGC/makemytrip/2.png',
        text: 'Select Net Banking under payment options'
      },
      {
        step: 3,
        image: '/assets/images/offlineGC/makemytrip/3.png',
        text: 'Scroll to the bottom & select ZestMoney EMI'
      },
      {
        step: 4,
        image: '/assets/images/offlineGC/makemytrip/4.png',
        text: 'Login with your ZestMoney credentials, complete your payment'
      },
    ]
  }
};

